
export const api = {
  "PORT": 3001,
  "HOST_URI": "https://dev.whiterobe.in/",
  "URI_PREFIX": "api_jobz/v1/",
  "production": false,
  "envLabel": "dev",
  "BLOG_API": "https://blog.whiterobe.in/",
  "CMS_API": "https://onlinecms.whiterobecdns.com/",
  "SOCKET_API": "https://dev.whiterobe.in:3006/",
  "SOCKET_PATH": "/socket.dev/socket.io",
  "AI_HOST_URI": "https://dev.whiterobe.in:3006/",
  "AI_URI_PREFIX": "ai/api/v1/"
};
